import { Box, Paper, Stack, Typography } from '@mui/material';

// ----------------------------------------------------------------------

interface Props {
  children: JSX.Element | JSX.Element[];
}

const TooltipContainer: React.FC<Props> = ({ children }) => {
  return (
    <Paper
      sx={{
        py: 1,
        borderRadius: '8px !important',
        border: (theme) => `1px solid ${theme.palette.divider} !important`,
        maxWidth: '60vw'
      }}
    >
      {children}
    </Paper>
  );
};

interface TooltipRowProps {
  label: any;
  value?: number | string;
  showDot?: boolean;
  currentItem?: any;
}

const TooltipRow: React.FC<TooltipRowProps> = ({ label, value, showDot, currentItem }) => {
  return (
    <Stack
      gap={{ xs: 1, sm: 3 }}
      alignItems={'center'}
      direction={'row'}
      flexWrap={'wrap'}
      sx={{ px: 2, wordBreak: 'break-word' }}
      // sx={{ px: 2, wordBreak: 'break-word', maxWidth: '60vw' }}
      // className='MuiChartsTooltip-root'
      justifyContent={'space-between'}
    >
      <Stack spacing={1} alignItems={'center'} direction={'row'}>
        {showDot && (
          <Box>
            <Box
            sx={{
              boxShadow: 1,
              width: 12,
              height: 12,
              backgroundColor: currentItem?.color,
              borderRadius: '50%',
              border: '2px solid white',
            }}
          />
          </Box>
        )}
        <Typography variant='body2' sx={{ color: (theme) => theme.palette.grey[500] }}>{label}</Typography>
      </Stack>
      <Typography variant='body2'>{value}</Typography>
    </Stack>
  );
};

export { TooltipContainer, TooltipRow };
